type LoadingStateProps = {
  label?: string;
  className?: string;
  size?: "xs" | "sm" | "md";
  showLabel?: boolean;
};

const sizeStyles = {
  xs: { size: 26, ringWidth: 2, arcWidth: 3 },
  sm: { size: 40, ringWidth: 2, arcWidth: 4 },
  md: { size: 54, ringWidth: 3, arcWidth: 5 },
};

export function LoadingState({
  label = "Loading…",
  className = "",
  size = "sm",
  showLabel = true,
}: LoadingStateProps) {
  const spinnerStyle = sizeStyles[size] || sizeStyles.sm;
  return (
    <div
      className={`inline-flex flex-col items-center gap-2 text-sm text-[rgb(var(--color-muted))] ${className}`}
    >
      <span
        className="relative inline-flex items-center justify-center"
        style={{ width: spinnerStyle.size, height: spinnerStyle.size }}
        aria-hidden="true"
      >
        <span
          className="absolute inset-0 rounded-full border-[rgb(var(--color-border))]/70"
          style={{ borderWidth: spinnerStyle.ringWidth }}
        />
        <span
          className="absolute inset-0 rounded-full border-transparent border-t-[rgb(var(--color-accent))] animate-spin"
          style={{
            borderWidth: spinnerStyle.arcWidth,
            boxShadow: "0 0 12px rgba(37, 99, 235, 0.35)",
          }}
        />
      </span>
      {showLabel ? <span className="text-center">{label}</span> : null}
    </div>
  );
}
